/* AAA LP — behavior for the landing page / listicle sections (sections/aaa-lp-*.liquid).
   Click handling is delegated from document, so it keeps working after the theme
   editor re-renders a section. Only the sticky bar needs per-section setup. */
(function () {
  if (window.__aaaLp) return;
  window.__aaaLp = true;

  /* Toggle card (aaa-lp-toggle): buttons [data-alp-tab] switch panels [data-alp-panel]. */
  function showTab(root, key) {
    root.querySelectorAll('[data-alp-tab]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-alp-tab') === key ? 'true' : 'false');
    });
    root.querySelectorAll('[data-alp-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-alp-panel') !== key;
    });
  }

  /* Review grid (aaa-lp-reviews): topic filter + show more. */
  function applyReviews(root) {
    var topic = root.getAttribute('data-alp-topic') || 'all';
    var expanded = root.getAttribute('data-alp-expanded') === 'true';
    var limit = parseInt(root.getAttribute('data-alp-limit'), 10) || 0;
    var shown = 0;
    var hiddenByLimit = 0;
    root.querySelectorAll('[data-alp-review]').forEach(function (card) {
      var topics = (card.getAttribute('data-topics') || '').split('|');
      var match = topic === 'all' || topics.indexOf(topic) !== -1;
      var overLimit = limit > 0 && !expanded && shown >= limit;
      if (match && overLimit) hiddenByLimit++;
      card.hidden = !match || overLimit;
      if (match && !overLimit) shown++;
    });
    var more = root.querySelector('[data-alp-more]');
    if (more) more.hidden = hiddenByLimit === 0;
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-alp-tab]');
    if (tab) {
      var tRoot = tab.closest('[data-alp-toggle]');
      if (tRoot) showTab(tRoot, tab.getAttribute('data-alp-tab'));
      return;
    }
    var filter = e.target.closest('[data-alp-filter]');
    if (filter) {
      var fRoot = filter.closest('[data-alp-reviews]');
      if (!fRoot) return;
      fRoot.querySelectorAll('[data-alp-filter]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === filter ? 'true' : 'false');
      });
      fRoot.setAttribute('data-alp-topic', filter.getAttribute('data-alp-filter'));
      fRoot.setAttribute('data-alp-expanded', 'false');
      applyReviews(fRoot);
      return;
    }
    var more = e.target.closest('[data-alp-more]');
    if (more) {
      var mRoot = more.closest('[data-alp-reviews]');
      if (!mRoot) return;
      mRoot.setAttribute('data-alp-expanded', 'true');
      applyReviews(mRoot);
    }
  });

  /* Sticky bar (aaa-lp-sticky-bar): appears after scrolling past the offset and
     hides while the element named in data-hide-on (e.g. #shop) is on screen. */
  function initSticky(bar) {
    if (bar.__alpInit) return;
    bar.__alpInit = true;
    var offset = parseInt(bar.getAttribute('data-offset'), 10) || 600;
    var hideSel = bar.getAttribute('data-hide-on');
    var hideEl = null;
    try { hideEl = hideSel ? document.querySelector(hideSel) : null; } catch (err) { hideEl = null; }
    var hideVisible = false;
    function update() {
      bar.classList.toggle('is-on', window.scrollY > offset && !hideVisible);
    }
    if (hideEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        hideVisible = entries[0].isIntersecting;
        update();
      }).observe(hideEl);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* Callouts (aaa-lp-callouts): turn each arrow so it points at the middle of
     the center image. Re-aims whenever the layout changes size. */
  function aimOrbit(orbit) {
    var center = orbit.querySelector('.alp-orbit__center');
    if (!center) return;
    var c = center.getBoundingClientRect();
    if (!c.width) return;
    var cx = c.left + c.width / 2;
    var cy = c.top + c.height / 2;
    orbit.querySelectorAll('.alp-orbit__arrow').forEach(function (a) {
      var r = a.getBoundingClientRect();
      var deg = Math.atan2(cy - (r.top + r.height / 2), cx - (r.left + r.width / 2)) * 180 / Math.PI;
      a.style.transform = 'rotate(' + deg.toFixed(1) + 'deg)';
    });
  }
  function initOrbit(orbit) {
    if (orbit.__alpInit) return;
    orbit.__alpInit = true;
    aimOrbit(orbit);
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { aimOrbit(orbit); }).observe(orbit);
    } else {
      window.addEventListener('resize', function () { aimOrbit(orbit); });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-alp-reviews]').forEach(applyReviews);
    (scope || document).querySelectorAll('[data-alp-sticky]').forEach(initSticky);
    (scope || document).querySelectorAll('[data-alp-orbit]').forEach(initOrbit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Theme editor: selecting a hidden review card or a toggle item in the
     sidebar reveals it, so every block can be edited in place. */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var panel = el.closest && el.closest('[data-alp-panel]');
    if (panel && panel.hidden) {
      var tRoot = panel.closest('[data-alp-toggle]');
      if (tRoot) showTab(tRoot, panel.getAttribute('data-alp-panel'));
    }
    if (el.hasAttribute && el.hasAttribute('data-alp-review') && el.hidden) {
      var rRoot = el.closest('[data-alp-reviews]');
      if (rRoot) {
        rRoot.setAttribute('data-alp-topic', 'all');
        rRoot.setAttribute('data-alp-expanded', 'true');
        applyReviews(rRoot);
      }
    }
  });
})();
